/** @format */

import React, { useState, useEffect } from "react";
import Dropzone from "react-dropzone";
import { FormatOnlyDate } from "components/FormatDate";
import { BasicAlert } from "components/Alert";
import useSettings from "stores/settings";
// import LikeUpdate from "function/LikeUpdate";
import HistorySave from "function/HistorySave";
import fetch from "node-fetch";

import Paper from "@material-ui/core/Paper";
import { EditingState } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, TableInlineCellEditing, TableColumnResizing } from "@devexpress/dx-react-grid-material-ui";

import jwtToken from "function/JwtToken";
import { projectStorage } from "components/ProjectStorage";
import * as jwt from "jsonwebtoken";
import { JsonWebTokenCheck } from "function/JsonWebTokenCheck";

import DataAnalysisDetailTab from "components/dataAnalysisTabs/DataAnalysisDetailTab";

const AppBody = ({
  email,
  appId,
  inputType,
  outputType,
  appName,
  price,
  userName,
  inputFile,
  target,
  csvInfo,
  outputJson,
  outputHtml,
  category,
}) => {
  const settings = useSettings();

  /** 업로드 파일 값 저장 */
  const [uploadFileCheck, setUploadFileCheck] = useState("none");
  const [file, setFile] = useState();
  const [testType, setTestType] = useState(false);
  const [outputFile, setOutputFile] = useState();

  /** csv 데이터 값 저장 */
  const [columns, setColumns] = useState([]);
  const [fields, setFields] = useState([]);
  // const [columnList, setColumnList] = useState([]);

  /** 테이블로 보여줄 결과 값 저장 */
  const [columnDefs, setColumnDefs] = useState([]);
  const [rowData, setRowData] = useState([]);

  /** 샘플 파일 데이터 저장 */
  const [downloadFileData, setDownloadFileData] = useState();

  const [getUrl, setGetUrl] = useState();

  /* 사용자 이메일 정보 저장 */
  const [userEmail, setUserEmail] = useState("");

  /* tab */
  const [tab, setTab] = useState("file");

  /* 입력 테이블 값 저장 및 수정 */
  const [defaultColumnWidths, setDefaultColumnWidths] = useState();
  const commitChanges = ({ changed }) => {
    let changedRows;
    if (changed) {
      changedRows = fields.map((row) => (changed[0] ? { ...row, ...changed[0] } : row));
    }
    setFields(changedRows);
  };

  /* 로그인 체크, 이메일 정보 저장 */
  useEffect(() => {
    if (settings.email) {
      setUserEmail(settings.email);
    } else {
      /* 비회원인 경우 */
      const guestTokenValue = window.localStorage.getItem("guestToken");

      // const tokenParseValue = jwt.verify(guestTokenValue, process.env.SECRET_CODE);
      if (guestTokenValue === "" || guestTokenValue === null) {
        settings.login = false;
        settings.email = "";
        settings.name = "";
        settings.photo = "";
        settings.uid = "";
        // window.localStorage.removeItem("aisoToken");
      } else {
        jwt.verify(guestTokenValue, process.env.SECRET_CODE, async (error, decoded) => {
          if (error) {
            console.log("게스트 인증 만료");
            JsonWebTokenCheck(settings);
          } else {
            const { guestId } = decoded;

            setUserEmail(guestId);
          }
        });
      }
    }
  }, [settings]);

  /**
   * input File => csv 파일 읽어오기
   * 입력값 및 샘플 데이터 값을 저장하기 위함.
   * */

  useEffect(async () => {
    if (inputFile) {
      const storageFileRef = projectStorage.ref(inputFile);
      storageFileRef
        .getDownloadURL()
        .then(function (url) {
          setGetUrl(url);
        })
        .catch(function (error) {
          console.log("error : ", error);
        });
    }
  }, []);
  useEffect(async () => {
    if (getUrl) {
      /** csv 파일 읽기 */
      const res = await fetch(getUrl);
      const result = await res.text();
      if (result !== "" && result.indexOf("<!DOCTYPE html><html><head>") === -1) {
        const rows = await result.split("\n");
        const columnString = await rows[0];
        const fieldString = await rows[1];
        const column = columnString.replace(/(\")/g, "").split(",");
        const field = fieldString.replace(/(\")/g, "").split(",");

        /* 타켓 제거 */
        let tempColumn = column;
        let tempField = field;
        for (let i in target) {
          const findIndex = column.findIndex((f) => f == target[i]);
          tempColumn = tempColumn.filter((f) => f !== target[i]);
          tempField = tempField.filter((f, index) => index !== findIndex);
        }

        const tempInputColumns = [];
        const tempDefaultColumnWidths = [];
        for (let i = 0; i < tempColumn.length; i++) {
          if (tempColumn[i]) {
            const value = tempColumn[i].trim();
            const tempColumn2 = {
              name: value,
              title: value,
            };

            const tempColumn3 = {
              columnName: value,
              width: 180,
            };
            await tempInputColumns.push(tempColumn2);
            await tempDefaultColumnWidths.push(tempColumn3);
          }
        }

        const tempInputFields = [];
        const tempField2 = new Object();
        for (let i = 0; i < tempField.length; i++) {
          if (tempColumn[i]) {
            const value = tempColumn[i].trim();
            tempField2[value] = tempField[i];
          }
        }
        tempInputFields.push(tempField2);

        setColumns(tempInputColumns);
        setFields(tempInputFields);
        setDefaultColumnWidths(tempDefaultColumnWidths);

        /** 다운로드 받을 샘플 데이터 저장 */
        let tempDownloadFileData = "";
        tempColumn.map((m) => (tempDownloadFileData += m + ","));
        tempDownloadFileData = tempDownloadFileData.substring(0, tempDownloadFileData.length - 1);
        tempDownloadFileData += "\n";
        tempField.map((m) => (tempDownloadFileData += m + ","));
        tempDownloadFileData = tempDownloadFileData.substring(0, tempDownloadFileData.length - 1);

        setDownloadFileData(tempDownloadFileData);
      }
    }
  }, [getUrl]);

  /** 파일 업로드 */
  const onDrop = async (acceptedFiles) => {
    if (!acceptedFiles[0]) return "";

    setOutputFile();
    setUploadFileCheck("uploading");
    setFile(acceptedFiles[0]);
    setTestType(true);

    const fileName = acceptedFiles[0].name;
    const createdAt = FormatOnlyDate(new Date());
    const storageFilePath = `users/${userEmail}/dataAnalysis/inputFile/file_${createdAt}_${fileName}`;
    const storageFileRef = projectStorage.ref(storageFilePath);

    /** 파일 업로드 */
    if (acceptedFiles[0]) {
      storageFileRef.put(acceptedFiles[0]).on(
        "state_changed",
        (snap) => {
          let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
          console.log(percentage);
          // setProgress(percentage);
        },
        (err) => {
          console.log("err :: ", err);
        },
        async () => {
          const inputUrl = `https://storage.cloud.google.com/aiso-api.appspot.com/${storageFilePath}`;
          dataAnalysisTestSend(inputUrl, fileName, storageFilePath);
        }
      );
    }
  };

  /** 파일 업로드 이후 데이터 분석 실행 */
  const dataAnalysisTestSend = async (inputUrl, fileName, storageFilePath) => {
    const sendData = {
      input_url: inputUrl,
      appId,
      email: userEmail,
      appEmail: email,
      method: "file",
      runType: "dataAnalysis_app",
    };
    /* firebase id token */
    const idToken = await jwtToken();
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`,
      },
      method: "POST",
      body: JSON.stringify(sendData),
    };
    const jsonData = await fetch(`${process.env.DATAANALYSIS_APP_URL}`, requestOptions);
    const result = await jsonData.json();

    if (result.msg === "ok") {
      const outputUrl = result["output_url"].replace(process.env.GOOGLE_CLOUD_STORAGE_URL, "");
      /* output 파일 다운받기 */
      // await downloadUrlSave(outputUrl);
      setOutputFile(outputUrl);
      setUploadFileCheck("uploaded");
      // setTestType(true);

      /*
      1. 앱 실행 결과 저장하기
      저장 경로 : users/{ 사용자 email }/history/{RandomId}/
      저장 정보 : appId, appName, email(개발자 이메일), userName(개발자 이름), createdAt, inputFile, outputFile, price, review, reviewedAt, comment, commentedAt, like
      */

      if (settings.email) {
        await HistorySave(outputUrl, storageFilePath, appId, appName, email, userName, inputType, outputType, price, userEmail, category);
      }
    } else {
      const text = result.msg;
      BasicAlert(text);

      setOutputFile();
      setUploadFileCheck("none");
      setTestType(false);
      // return "";
    }
  };

  /** 파일 다운로드 */
  function linkDownload(filename, content) {
    const link = document.createElement("a");
    const contentType = "data:application/csv;charset=utf-8,";
    const uriContent = contentType + encodeURIComponent(content);
    link.setAttribute("href", uriContent);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleFileDownload = async () => {
    const storageFileRef = projectStorage.ref(outputFile);
    storageFileRef
      .getDownloadURL()
      .then(async function (url) {
        /** csv 파일 읽기 */
        const res = await fetch(url);
        const result = await res.text();
        if (result !== "" && result.indexOf("<!DOCTYPE html><html><head>") === -1) {
          linkDownload(file.name, result);
        }
      })
      .catch(function (error) {
        console.log("error : ", error);
      });
  };

  /** 데이터 분석 샘플 데이터 다운로드 */
  const handleSampleFileDownload = () => {
    linkDownload("analysis_sample_data.csv", downloadFileData);
  };

  /** 테스트 데이터 값 직접 입력 이후 데이터 분석 실행 */
  const handleTestAnalysis = async () => {
    /* 파일 이름 지정 */
    const tempFile = new Object();
    tempFile.name = `${appName}_inputData.csv`;
    setFile(tempFile);

    setColumnDefs([]);
    setRowData([]);
    setUploadFileCheck("uploading");
    setTestType(false);

    const userInput = new Object();

    for (let i in Object.keys(fields[0])) {
      const tempFields = Object.keys(fields[0]);
      const tempColumn = tempFields[i];
      const tempValue = Object.values(fields[0])[i];
      userInput[`${tempColumn}`] = [`${tempValue}`];
    }

    const method = "userInput"; // file or userInput;
    const sendData = {
      email: userEmail,
      appId,
      appEmail: email,
      method,
      userInput,
      runType: "dataAnalysis_app",
    };

    /* firebase id token */
    const idToken = await jwtToken();
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`,
      },
      method: "POST",
      body: JSON.stringify(sendData),
    };
    const jsonData = await fetch(`${process.env.DATAANALYSIS_APP_URL}`, requestOptions);
    const result = await jsonData.json();

    if (result.msg === "ok") {
      const outputUrl = result["output_url"].replace(process.env.GOOGLE_CLOUD_STORAGE_URL, "");

      /*
      1. 앱 실행 결과 저장하기
      저장 경로 : users/{ 사용자 email }/history/{RandomId}/
      저장 정보 : appId, appName, email(개발자 이메일), userName(개발자 이름), createdAt, inputFile, outputFile, price, review, reviewedAt, comment, commentedAt, like
      */

      if (settings.email) {
        await HistorySave(outputUrl, "", appId, appName, email, userName, inputType, outputType, price, userEmail, category);
      }

      // 결과 값 보여주기....

      if (outputUrl) {
        const storageFileRef = projectStorage.ref(outputUrl);
        storageFileRef
          .getDownloadURL()
          .then(async function (url) {
            /** csv 파일 읽기 */
            const res = await fetch(url);
            const result = await res.text();
            if (result !== "" && result.indexOf("<!DOCTYPE html><html><head>") === -1) {
              const rows = result.split("\n");
              const column = rows[0].split(",");

              let tempColumnDefs = [];
              for (let i = 0; i < column.length; i++) {
                const tempColumn = { headerName: column[i], cellStyle: { "border-right-color": "#e2e2e2" }, field: column[i] };
                tempColumnDefs.push(tempColumn);
              }

              // -1 하는 이유 : 엔터 값 제거
              let tempRowData = [];
              for (let i = 1; i < rows.length - 1; i++) {
                const row = rows[i].split(",");
                const tempField = new Object();
                for (let j = 0; j < row.length; j++) {
                  tempField[column[j]] = row[j].toString();
                }
                tempRowData.push(tempField);
              }

              /* output 파일 다운받기 */
              setOutputFile(outputUrl);

              /* 결과 값 저장 */
              setColumnDefs(tempColumnDefs);
              setRowData(tempRowData);
              setUploadFileCheck("uploaded");
              setTestType(false);
            } else {
              const text = (
                <div>
                  <div>분석에 실패하였습니다.</div>
                  <div className="mt-1">데이터를 확인 해주세요.</div>
                </div>
              );
              BasicAlert(text);
              setUploadFileCheck("none");
              setFile();
              setTestType(false);
            }
          })
          .catch(function (error) {
            console.log("error : ", error);
          });
      }
    } else {
      const text = result.msg;
      BasicAlert(text);
      setUploadFileCheck("none");
      setTestType(false);
    }
  };

  return (
    <div className="w-full px-6 md:px-32">
      <div className="pt-10 pb-4 sm:flex justify-between items-start">
        <p className="text-xl font-bold text-black break-all sm:pr-5">{appName}</p>
        <p className="text-base text-black font-gmarket-medium font-bold min-w-max flex justify-end items-center">
          <span className="font-bold text-lg text-black mr-1">{price}</span> Credit
        </p>
      </div>
      <div className="overflow-x-auto">
        <ul className="flex w-full">
          <li>
            <button
              type=""
              className={`btn glass_in_outline_btn font-bold min-w-max mr-3 ${tab === "file" ? "active" : ""}`}
              onClick={() => setTab("file")}
            >
              파일 업로드
            </button>
          </li>
          <li>
            <button
              type=""
              className={`btn glass_in_outline_btn font-bold min-w-max ${tab === "input" ? "active" : ""}`}
              onClick={() => setTab("input")}
            >
              데이터 입력
            </button>
          </li>
        </ul>
      </div>
      {/* 업로드 하여 테스트 */}
      {tab === "file" ? (
        <FileTable
          uploadFileCheck={uploadFileCheck}
          file={file}
          handleFileDownload={handleFileDownload}
          handleSampleFileDownload={handleSampleFileDownload}
          onDrop={onDrop}
        />
      ) : (
        ""
      )}
      {/* 데이터 입력 하여 테스트 */}
      {tab === "input" ? (
        <div className="h-full flex flex-col sm:flex-row items-center aiso-data-card shadow-md mb-3">
          <div className="w-full px-3 py-4">
            <h5 className="mb-4 font-bold center">데이터를 입력하여 테스트해 보세요</h5>
            <div className="w-full">
              {/* 전체 앱 */}
              <InputTable
                columns={columns}
                fields={fields}
                commitChanges={commitChanges}
                defaultColumnWidths={defaultColumnWidths}
                handleTestAnalysis={handleTestAnalysis}
                uploadFileCheck={uploadFileCheck}
                testType={testType}
                columnDefs={columnDefs}
                rowData={rowData}
              />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {/* 컬럼 설명 */}
      <DataAnalysisDetailTab csvInfo={csvInfo} target={target} outputJson={outputJson} outputHtml={outputHtml} />
    </div>
  );
};

/* 파일 업로드 테이블 */
const FileTable = ({ uploadFileCheck, file, handleFileDownload, onDrop, handleSampleFileDownload }) => {
  return (
    <div className="h-full flex flex-col sm:flex-row items-center aiso-data-card shadow-md mb-3">
      <div className="w-full px-3 py-4">
        <div className="row  center">
          <div className="col-12 col-md-7">
            {uploadFileCheck === "uploaded" ? (
              <section className="center bg-gray-input h-44 rounded-2xl">
                <div className="w-full flex items-center justify-center mt-4">
                  <p className="text-999">{file.name}</p>
                </div>
                <div className="w-full text-center m-2">
                  <button type="button" className="btn btn-primary btn-icon-text" onClick={handleFileDownload}>
                    <i className="ti-download btn-icon-prepend" />
                    결과 다운로드
                  </button>
                </div>
                <Dropzone accept=".csv" onDrop={onDrop} multiple={false}>
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} className="w-full flex flex-col items-center justify-center mt-3">
                      <div className="w-full flex items-center justify-center">
                        <input {...getInputProps()} />
                        <i className="mdi mdi-refresh"></i>
                        <p className="btn text-xs btn-whitePrimary py-2 px-3">앱 재실행은 여기를 눌러주세요.</p>
                      </div>
                    </div>
                  )}
                </Dropzone>
              </section>
            ) : (
              <Dropzone accept=".csv" onDrop={onDrop} multiple={false}>
                {({ getRootProps, getInputProps }) =>
                  file ? (
                    <section className="center bg-gray-input h-52 rounded-2xl">
                      <div {...getRootProps()} className="w-full flex flex-col items-center justify-center mt-4">
                        <div className="z-50 loader-demo-box2 mt-2">
                          <div className="dot-opacity-loader">
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                        </div>
                        <div className="w-full text-center -mt-6">
                          <p className="text-888 mt-2 font-bold">데이터 분석중 입니다.</p>
                          <p className="text-888 font-bold">잠시만 기다려주세요.</p>
                        </div>
                      </div>
                    </section>
                  ) : (
                    <section className="w-full h-52 rounded-2xl bg-gray-input flex items-center">
                      <div {...getRootProps()} className="w-full flex flex-col items-center justify-center mt-4">
                        <h5 className="mb-4 font-bold text-aaa">파일을 업로드하여 테스트해 보세요</h5>
                        <div className="upload-circle-wrap">
                          <div className="upload-circle"></div>
                          <i className="ti-upload text-primary font-bold absolute"></i>
                        </div>
                        <p className="text-primary font-bold mt-2">Choose File</p>
                        <div className="w-full flex items-center justify-center">
                          <input {...getInputProps()} />
                          <p className="text-aaa">Drag and drop your files here</p>
                        </div>
                      </div>
                    </section>
                  )
                }
              </Dropzone>
            )}
          </div>
        </div>
        <div className="row center mt-2">
          <div className="col-12 col-md-7">
            <div className="p-3 bg-gray-input rounded-xl">
              <div className="md:flex  justify-between items-center">
                <div className="flex flex-col items-start lg:mb-0 mb-2">
                  <h5 className="mb-0">테스트할 파일이 없으신가요?</h5>
                  <p className="text-888 mb-0 text-xs">아이소에서 제공하는 csv테스트 파일을 사용하여 테스트해 보세요</p>
                </div>
                <button type="text" className="btn btn-whitePrimary font-bold" onClick={handleSampleFileDownload}>
                  파일 다운로드
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* 데이터 입력 테이블 */
const InputTable = ({
  columns,
  fields,
  commitChanges,
  defaultColumnWidths,
  handleTestAnalysis,
  uploadFileCheck,
  testType,
  rowData,
  columnDefs,
}) => {
  if (!defaultColumnWidths) return "";
  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);

  const handleAnalysisButton = () => {
    handleTestAnalysis();
  };

  useEffect(() => {
    setColumnWidths(defaultColumnWidths);
  }, [defaultColumnWidths]);
  return (
    <div className="w-full border-t mt-4 pt-3">
      <div className="overflow-x-auto">
        <div className="flex flex-col w-full">
          <div className="border-t">
            <Paper>
              <Grid rows={fields} columns={columns}>
                <EditingState onCommitChanges={commitChanges} />
                <Table />
                {columnWidths ? <TableColumnResizing defaultColumnWidths={columnWidths} /> : ""}
                <TableHeaderRow />
                <TableInlineCellEditing />
              </Grid>
            </Paper>
          </div>
          {testType ? (
            ""
          ) : uploadFileCheck === "uploading" ? (
            <section className="mt-16 center bg-gray-input h-44 rounded-2xl">
              <div className="w-full flex flex-col items-center justify-center mt-4">
                <div className="z-50 loader-demo-box2 mt-2">
                  <div className="dot-opacity-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div className="w-full text-center -mt-6">
                  <p className="text-888 mt-2 font-bold">분석결과 입력중 입니다.</p>
                  <p className="text-888 font-bold">잠시만 기다려주세요.</p>
                </div>
              </div>
            </section>
          ) : (
            rowData &&
            rowData.length > 0 && (
              <div className="row flex items-center justify-center mt-16">
                {columnDefs.length > 0 && (
                  <div className="flex font-bold text-333 py-2 px-3 bg-gray-input rounded-md mr-3 mb-2.5">
                    <p className="mb-0 text-aaa font-bold mr-3 text-lg">{columnDefs[columnDefs.length - 1].field}</p>
                    <p className="mt-1 font-bold text-333 bg-gray-input rounded-md">
                      {rowData[0][columnDefs[columnDefs.length - 1].field]}
                    </p>
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>
      <div className="flex justify-end mt-2">
        <button className="btn btn-primary text-xs px-2.5 py-1.5" onClick={handleAnalysisButton}>
          분석하기
        </button>
      </div>
    </div>
  );
};

/* 파일 설명 */
/* 데이터 분석 */
/* 알고리즘 */

export default AppBody;
